// Realitní kancelář – galerie detailu nabídky ([data-ro-gallery], markup detail/gallery.php, návrh ř. 346–354, 426–438).
// Bez JS jsou hlavní fotka i náhledy odkazy na velkou fotku (-1920). JS:
//  - klik na náhled přepne hlavní fotku (-1200) a štítek „{n} / {počet}“,
//  - klik na hlavní fotku otevře <dialog> s velkou fotkou, šipky (tlačítka i ←/→) listují dokola,
//    Escape zavře (nativně dialog), klik mimo fotku a tlačítka zavře.

export default function initRoGalleries() {
  document.querySelectorAll('[data-ro-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('[data-ro-gallery-main]');
    const mainImg = main?.querySelector('img');
    const count = gallery.querySelector('[data-ro-gallery-count]');
    const dialog = gallery.querySelector('[data-ro-lightbox]');
    const lbImg = dialog?.querySelector('[data-ro-lightbox-img]');
    const caption = dialog?.querySelector('[data-ro-lightbox-caption]');
    if (!main || !mainImg) {
      return;
    }
    const thumbs = Array.from(gallery.querySelectorAll('.ro-gallery__thumb'));
    const photos = thumbs.length
      ? thumbs.map((t) => ({ full: t.href, main: t.dataset.main, alt: t.dataset.alt || '' }))
      : [{ full: main.href, main: mainImg.src, alt: mainImg.alt }];
    let index = 0;

    const label = () => `${index + 1} / ${photos.length}`;

    const show = (i) => {
      index = (i + photos.length) % photos.length;
      const photo = photos[index];
      mainImg.src = photo.main;
      mainImg.alt = photo.alt;
      main.href = photo.full;
      if (count) {
        count.textContent = label();
      }
      thumbs.forEach((t, n) => {
        t.classList.toggle('is-active', n === index);
        if (n === index) {
          t.setAttribute('aria-current', 'true');
        } else {
          t.removeAttribute('aria-current');
        }
      });
      if (dialog?.open && lbImg) {
        lbImg.src = photo.full;
        lbImg.alt = photo.alt;
        if (caption) {
          caption.textContent = `${label()} — ${photo.alt}`;
        }
      }
    };

    thumbs.forEach((thumb, n) => {
      thumb.addEventListener('click', (event) => {
        event.preventDefault();
        show(n);
      });
    });

    if (!dialog || !lbImg || typeof dialog.showModal !== 'function') {
      return; // bez <dialog> zůstane odkaz na velkou fotku
    }

    main.addEventListener('click', (event) => {
      event.preventDefault();
      dialog.showModal();
      show(index);
    });

    dialog.querySelector('[data-ro-lightbox-close]')?.addEventListener('click', () => dialog.close());
    dialog.querySelectorAll('[data-ro-lightbox-step]').forEach((button) => {
      button.addEventListener('click', () => show(index + Number(button.dataset.roLightboxStep)));
    });
    dialog.addEventListener('click', (event) => {
      if (!event.target.closest('button, img')) {
        dialog.close();
      }
    });
    dialog.addEventListener('keydown', (event) => {
      if (photos.length > 1 && (event.key === 'ArrowLeft' || event.key === 'ArrowRight')) {
        event.preventDefault();
        show(index + (event.key === 'ArrowLeft' ? -1 : 1));
      }
    });
  });
}
